import { Pipe, PipeTransform } from '@angular/core';
import { SizePrice, OrderableIngredient, OrderableItem } from 'ngx-web-api';

@Pipe({
  name: 'sizePrice',
})
export class SizePricePipe implements PipeTransform {
  transform(pricedObject: OrderableIngredient | OrderableItem, size: string): SizePrice | undefined {
    if (!!pricedObject && !!size) {
      return pricedObject.getSizePrice(size);
    }
    return undefined;
  }
}
